import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueRouter from 'vue-router'
import { START_LOCATION } from 'vue-router'

import routes from './routes'
import { Auth } from '@/mixin/auth'


Vue.use(VueRouter);
Vue.use(VueMeta, {
    // The component option name that vue-meta looks for meta info on.
    keyName: "page",
});

const router = new VueRouter({
    routes,
    // Use the HTML5 history API (i.e. normal-looking routes)
    // instead of routes with hashes (e.g. example.com/#/about).
    // This may require some server configuration in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    mode: "history",
    base: process.env.NODE_ENV === "production" ? "/" : "/",
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  if (
      routeFrom === START_LOCATION &&
      localStorage.getItem("token") &&
      routeTo.name != "Tracking Termporary Liveview"
  ) {
      await Auth.methods.getAuth();
  }

  if (process.env.VUE_APP_DEFAULT_AUTH === 'authapi') {
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

        if (!authRequired) {
            return next();
        }

        // Checking for localstorage
        const token = localStorage.getItem("token");
        if (!token) {
            localStorage.removeItem("token");

            window.location.href = "/login";
        }

        const guestPage = routeTo.matched.some((route) => route.meta.guestPage);
        const hasDashboardAccess =
            process.env.VUE_APP_HAS_DASHBOARD_ACCESS || true;

        if (hasDashboardAccess === "false" && !guestPage) {
            localStorage.removeItem("token");

            window.location.href = "/login";
        }

        const hasAccess = routeTo.matched.some((route) => route.meta.hasAccess);
        if (!hasAccess) {
            window.location.href = "/";
        }

        if (routeFrom.name === "Track Video") {
            const answer = window.confirm(
                "Apakah anda ingin menghentikan pelacakan video?"
            );
            if (answer) {
                next();
            } else {
                window.onbeforeunload = function () {
                    return "Apakah anda ingin menghentikan pelacakan video?";
                };
                next(false);
            }
        } else {
            next();
        }
    } else {
        // ini hanya sementara, lewatkan semua pengecekan menu yang required
        // saat ini masih manual disetiap route menu di route.js
        next();
    }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
    // Create a `beforeResolve` hook, which fires whenever
    // `beforeRouteEnter` and `beforeRouteUpdate` would. This
    // allows us to ensure data is fetched even when params change,
    // but the resolved route does not. We put it in `meta` to
    // indicate that it's a hook we created, rather than part of
    // Vue Router (yet?).
    try {
        // For each matched route...
        for (const route of routeTo.matched) {
            await new Promise((resolve, reject) => {
                // If a `beforeResolve` hook is defined, call it with
                // the same arguments as the `beforeEnter` hook.
                if (route.meta && route.meta.beforeResolve) {
                    route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                        // If the user chose to redirect...
                        if (args.length) {
                            // If redirecting to the same route we're coming from...
                            // Complete the redirect.
                            next(...args);
                            reject(new Error("Redirected"));
                        } else {
                            resolve();
                        }
                    });
                } else {
                    // Otherwise, continue resolving the route.
                    resolve();
                }
            });
        }
        // If a `beforeResolve` hook chose to redirect, just return.
    } catch (error) {
        return;
    }

    // If we reach this point, continue resolving the route.
    next();
});

export default router;
